import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {VelocityComponent} from 'velocity-react';
import 'velocity-animate/velocity.ui';
import HeaderTags from "../elements/HeaderTags";
import { normalizeHelmetTitle } from "../../../config/normalizeHelmetTitle";

const AppAnimate = React.forwardRef((props, ref) => {
  const { title, children: childElement, ...velocityProps } = props;
  const children = React.cloneElement(childElement, {
    style: {
      ...childElement.style,
      visibility: 'hidden',
    },
  });
  const helmetTitle = title != null && title !== '' ? normalizeHelmetTitle(title) : null;

  return (
    <VelocityComponent ref={ref} {...velocityProps}>
      {helmetTitle ? <HeaderTags title={helmetTitle} /> : null}
      {children}
    </VelocityComponent>
  );
});

AppAnimate.propTypes = {
  children: PropTypes.element.isRequired,
};

AppAnimate.defaultProps = {
  animation: 'transition.fadeIn',
  runOnMount: true,
  targetQuerySelector: null,
  interruptBehavior: 'stop',
  visibility: 'visible',
  duration: 400,
  delay: 100,
  easing: [0.4, 0.0, 0.2, 1],
  display: null,
  setRef: undefined,
};

export default memo(AppAnimate);
